export enum UserRole {
  CLEANER = 'CLEANER',
  MANAGER = 'MANAGER',
  DIRECTOR = 'DIRECTOR'
}

export enum TaskStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
  branches?: UserBranch[];
}

export interface Company {
  id: string;
  name: string;
  address: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
  branch?: Branch;
  branchId?: string;
}

export interface Individual {
  id: string;
  name: string;
  address: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
  branch?: Branch;
  branchId?: string;
}

export interface Task {
  id: string;
  location: string;
  dateTime: string;
  status: TaskStatus;
  notes?: string;
  amount?: number;
  companyId?: string;
  individualId?: string;
  company?: Company;
  individual?: Individual;
  responsibleId?: string;
  responsible?: User;
  beforePhoto?: string[];
  duringPhoto?: string[];
  afterPhoto?: string[];
  createdAt: string;
  updatedAt: string;
  categoryId: string;
  category?: Category;
  evaluation?: { [key: string]: number };
  signature?: string;
  gastoEmpleados?: number | null;
  gastoInsumos?: number | null;
  gastoMaquinas?: number | null;
  branch?: Branch;
  branchId?: string;
  commission?: Commission;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}

export interface RootState {
  auth: AuthState;
}

export interface Category {
  id: string;
  name: string;
  description?: string;
  evaluationFields?: string[];
  createdAt: string;
  updatedAt: string;
}

export interface QRCode {
  id: string;
  serviceName: string;
  companyId?: string;
  individualId?: string;
  categoryId: string;
  category?: Category;
  company?: Company;
  individual?: Individual;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Service {
  id: string;
  name: string;
  description?: string;
  companyId?: string;
  individualId?: string;
  company?: Company;
  individual?: Individual;
  qrCode: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  responsibles?: ServiceResponsible[];
  tasks?: ServiceTask[];
  dayComments?: ServiceDayComment[];
  _count?: {
    dayComments: number;
  };
  qrCodeImage?: string;
  branch?: Branch;
  branchId?: string;
}

export interface ServiceResponsible {
  id: string;
  serviceId: string;
  userId: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role?: UserRole;
  };
  createdAt: string;
}

export interface ServiceTask {
  id: string;
  serviceId: string;
  dayOfWeek: number; // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
  taskText: string;
  orderIndex: number;
  createdAt: string;
}

export interface ServiceDayComment {
  id: string;
  serviceId: string;
  userId: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  date: string;
  dayOfWeek: number;
  comment?: string;
  photos: string[];
  createdAt: string;
} 
export interface Branch {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  commissionRate: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    users: number;
    companies: number;
    tasks: number;
    scheduledServices: number;
  };
}

export interface UserBranch {
  id: string;
  userId: string;
  branchId: string;
  commissionRate?: number;
  isActive: boolean;
  assignedAt: string;
  user?: User;
  branch?: Branch;
}

export interface Commission {
  id: string;
  amount: number;
  rate: number;
  baseAmount: number;
  createdAt: string;
  userId: string;
  user?: User;
  branchId: string;
  branch?: Branch;
  taskId?: string;
  task?: Task;
  scheduledServiceId?: string;
  scheduledService?: any;
}

